import React, { useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { PageHeader, Button, notification } from "antd";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer, actions } from "./slice";
import { addTestSaga } from "./saga";
import * as selectors from "./selectors";
import routes from "../../../../../routes";
import AddTestForm from "../../../../forms/AddTestForm";
import schema from "../../../../schemas/addTestSchema";
import Loader from "../../../../components/Loader";

const AddTest = () => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: addTestSaga });
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(actions.fetchCommodityCategories());
    dispatch(actions.fetchDropdown(["currency"]));
    dispatch(actions.fetchCommodities());
    dispatch(actions.fetchTestCategories());
  }, [dispatch]);

  const testCategories = useSelector(selectors.selectTestCategories);
  const commodityCategories = useSelector(selectors.selectCommodityCategories);
  const commodities = useSelector(selectors.selectcommodities);
  const dropdowns = useSelector(selectors.selectDropdowns);
  const loading = useSelector(selectors.selectLoading);
  const error = useSelector(selectors.selectError);

  let modifiedDropdowns = null;
  if (dropdowns) {
    modifiedDropdowns = dropdowns.currency.filter(
      (dropdown) => dropdown.label === "INR"
    );
  }
  useEffect(() => {
    if (error && error !== "") {
      notification.error({
        message: "Error Creating Test",
        description: error,
      });
      setTimeout(() => {
        dispatch(actions.initializeError());
      }, 1500);
    }
  }, [error, dispatch]);

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      parameter: "",
      amount: "",
      currency: "",
      commodityCategory: "",
      commodity: "",
      testCategory: "",
      description: "",
    },
  });

  const handleSuccess = () => {
    notification.success({
      message: "Test got added",
    });
    history.push(routes.backOffice.catalog.master);
  };

  const handleFailure = () => {
    console.log("An error occured");
  };

  const onSubmit = (data) => {
    const payloadData = {
      parameter: data.parameter,
      price: parseInt(data.amount, 10),
      currency: data.currency,
      commodityCategory: data.commodityCategory,
      commodity: data.commodity,
      testCategory: data.testCategory,
      description: data.description,
    };
    const payload = {
      onSuccess: handleSuccess,
      data: payloadData,
      onFailure: handleFailure,
    };
    dispatch(actions.addTest(payload));
  };

  return (
    <div style={{ height: "100%" }}>
      <PageHeader
        ghost={false}
        title="New Test"
        extra={[
          <Button key="1">
            <Link to={routes.backOffice.catalog.master}>Cancel</Link>
          </Button>,
          <Button
            key="2"
            type="primary"
            disabled={loading}
            loading={loading}
            onClick={handleSubmit(onSubmit)}
          >
            Save
          </Button>,
        ]}
      />
      <div
        style={{
          height: "calc(100vh - 137px)",
          overflowY: "auto",
          padding: 24,
        }}
      >
        {loading ? <Loader /> : ""}
        <AddTestForm
          control={control}
          options={{
            testCategories,
            commodityCategories,
            commodities,
            currencies: modifiedDropdowns,
          }}
          watch={watch}
          errors={errors}
        />
      </div>
    </div>
  );
};

export default AddTest;
